import 'www/js/libs/magnific-popup/magnific-popup.css'
import 'www/js/libs/magnific-popup/jquery.magnific-popup.min'

function initChooseTownDialog() {
  const chooseTownDialogButton = $('.b-pd-nav__title-town-link')

  chooseTownDialogButton.on('click', () => {
    window.dispatchEvent(new CustomEvent('choose-town-dialog:open'))
  })
}

initChooseTownDialog()
